import { defineMessages } from 'react-intl';

export default defineMessages({
  selectSeller: {
    id: 'view.header.selectSeller',
    defaultMessage: 'Select seller',
  },
});
